import { connect } from 'react-redux';
import { TruckFormData, Truck } from '../../models/truck';
import ManifestTruckFormComponent from './ManifestTruckFormComponent';
import { groupLoadingRestrictions } from './TruckFormContainer';
import { generateManifest } from '../../store/actions/truck';
import { StoreState } from '../../store/state';

const defaultLinehaulCompany = {
  value: '',
  label: 'None',
};

const mapStateToProps = (state: StoreState) => ({
  selectedLocationKey: state.location.key,
  linehaulCompanies: [
    defaultLinehaulCompany,
    ...Object.values(state.linehaulCompanies.all).map(({ name, id }) => ({ label: name, value: id })) || [],
  ],
  customsBrokers: Object.values(state.customsBrokers.all).map(({ id, name }) => ({ label: name, value: id })) || [],
  truckLoadingRestrictions: groupLoadingRestrictions(state.loadingRestrictions.all || []),
});

const mapDispatchToProps = {
  submit: (manifestingTruck: TruckFormData) => generateManifest.request(manifestingTruck as Truck),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManifestTruckFormComponent);
